/* J·SKIN LAB — jsl-ui.js (RD2, 25.09.2026): wspólne stany elementów funkcyjnych, bez zmian logiki koszyka.
 *  1. Formularz /cart/add wysłany → przycisk dostaje aria-busy (kręciołek z jsl-ui.css, blokada drugiego kliknięcia)
 *     do zdarzenia motywu cart:update / cart:error (najdłużej 8 s). Animacja „Dodano ✓” motywu działa jak dotąd.
 *  2. Po udanym POST /cart/add (formularz motywu, kreator, zestawy, prezenty, panel) — jeśli szuflada się nie otworzyła
 *     i strona nie przechodzi dalej — komunikat „Dodano do koszyka” z linkiem do koszyka (role=status, znika po 4 s).
 *  Napisy z istniejących kluczy: products.product.added_to_cart, jsl.prezent.koszyk (21 języków).
 *  3. (RD3) Zakresy liczb „1–3 dni”, „10–15%”, „1–2 razy”: niewidoczny łącznik U+2060 po obu stronach myślnika, żeby
 *     linia nie łamała się na „1–” / „3 dni”. Na stronach PL także twarda spacja po „z/w/i/a/o/u” i przed ml, g, szt., dni, zł, pkt.
 *     Tekst dla oka bez zmian; działa też po odświeżeniu szuflady i sekcji (MutationObserver). */
(function () {
  if (window.__jslUi) return; window.__jslUi = true;
  var s = document.currentScript, D = (s && s.dataset) || {};
  var odjazd = false; window.addEventListener('pagehide', function () { odjazd = true; }); window.addEventListener('beforeunload', function () { odjazd = true; });

  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var b = e.submitter || f.querySelector('button[type="submit"],button[name="add"]');
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    var t = setTimeout(zdejmij, 8000);
    function zdejmij() { clearTimeout(t); b.removeAttribute('aria-busy'); document.removeEventListener('cart:update', zdejmij); document.removeEventListener('cart:error', zdejmij); }
    document.addEventListener('cart:update', zdejmij); document.addEventListener('cart:error', zdejmij);
  }, true);

  var toast, zegar;
  function pokaz() {
    if (odjazd || !D.dodano) return;
    if (document.querySelector('cart-drawer-component dialog[open], dialog.cart-drawer__dialog[open]')) return;
    var naKoszyku = !!document.querySelector('.cart-page, [data-template="cart"]') || /\/cart\/?$/.test(location.pathname);
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'j-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="j-toast__ik" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span><span class="j-toast__t"></span><a></a>';
      document.body.appendChild(toast);
    }
    toast.querySelector('.j-toast__t').textContent = D.dodano;
    var a = toast.querySelector('a'); a.textContent = D.koszyk || ''; a.href = D.url || '/cart'; a.hidden = naKoszyku || !D.koszyk;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(zegar); zegar = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
  }


  // 3. RD3: zakres liczb nie łamie się w połowie („w 1–” / „3 dni robocze”); na stronach PL także sieroty i jednostki
  //    (napisy motywu z plików językowych nie przechodzą przez snippet jsl10-nbsp, który robi to samo dla tekstów z danych)
  var PL = /^pl/i.test(document.documentElement.lang || '');
  var ZAKRES = /(\d)([\u2013\u2014-])(?=\d)/g, SIEROTA = /(^|[\s(„])([zwiaouZWIAOU])\s(?=\S)/g, JEDN = /(\d)\s(?=(ml|g|szt\.?|dni|zł|pkt)(?![\p{L}]))/gu;
  var CZY = PL ? /\d[\u2013\u2014-]\d|(^|[\s(„])[zwiaouZWIAOU]\s\S|\d\s(ml|g|szt|dni|zł|pkt)/ : /\d[\u2013\u2014-]\d/;
  var POMIN = /^(SCRIPT|STYLE|TEXTAREA|INPUT|CODE|PRE|NOSCRIPT|OPTION)$/;
  function popraw(t) {
    t = t.replace(ZAKRES, '$1\u2060$2\u2060');
    if (PL) t = t.replace(SIEROTA, '$1$2\u00a0').replace(SIEROTA, '$1$2\u00a0').replace(JEDN, '$1\u00a0');
    return t;
  }
  function wiaz(root) {
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      return n.nodeValue.length > 2 && CZY.test(n.nodeValue) && !(n.parentNode && POMIN.test(n.parentNode.nodeName)) ? 1 : 3; } });
    var n, lista = []; while ((n = w.nextNode())) lista.push(n);
    for (var i = 0; i < lista.length; i++) { var v = lista[i].nodeValue, z = popraw(v); if (z !== v) lista[i].nodeValue = z; }
  }
  function start() {
    wiaz(document.body);
    if (!window.MutationObserver) return;
    // nowe fragmenty (szuflada, sekcje odświeżane przez motyw) zbierane i poprawiane raz na klatkę
    var kolejka = [], zaplanowane = false;
    function przerob() { zaplanowane = false; var k = kolejka; kolejka = []; for (var i = 0; i < k.length; i++) if (k[i].isConnected) wiaz(k[i]); }
    new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) { var x = m[i].addedNodes[j]; var el = x.nodeType === 1 ? x : x.nodeType === 3 ? x.parentNode : null; if (el) kolejka.push(el); } if (kolejka.length && !zaplanowane) { zaplanowane = true; requestAnimationFrame(przerob); } })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  var of = window.fetch;
  if (typeof of === 'function') {
    window.fetch = function (u, o) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        var met = (o && o.method) || (u && u.method) || 'GET';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && /post/i.test(met)) {
          p.then(function (r) { if (r && r.ok) setTimeout(pokaz, 600); }, function () {});
        }
      } catch (_) {}
      return p;
    };
  }

  // 4. RD4 (25.09): paski przewijane w bok (kreator na telefonie: zakres, etapy, chipy) dostają sygnał „jest więcej” —
  //    atrybut data-j-przew = l / p / lp (z której strony jest ukryta treść); CSS wygasza tę krawędź. Pasek bez przewijania: bez atrybutu.
  var PRZEW = '.jk2-zak,.jk2-pw__c,.jk2-chipy,.jk2-etapy,[data-j-przew-auto]';
  function przew(e) {
    var m = e.scrollWidth - e.clientWidth;
    if (m < 2) { if (e.hasAttribute('data-j-przew')) e.removeAttribute('data-j-przew'); return; }
    var s = Math.abs(e.scrollLeft), v = (s > 4 ? 'l' : '') + (s < m - 4 ? 'p' : '');
    if (e.getAttribute('data-j-przew') !== v) e.setAttribute('data-j-przew', v);
  }
  var przewPlan = false;
  function przewWszystkie() { przewPlan = false; var l = document.querySelectorAll(PRZEW); for (var i = 0; i < l.length; i++) przew(l[i]); }
  function przewZaplanuj() { if (!przewPlan) { przewPlan = true; requestAnimationFrame(przewWszystkie); } }
  document.addEventListener('scroll', function (e) { var t = e.target; if (t && t.nodeType === 1 && t.matches && t.matches(PRZEW)) przew(t); }, { capture: true, passive: true });
  window.addEventListener('resize', przewZaplanuj, { passive: true });
  window.addEventListener('load', przewZaplanuj);
  if (window.MutationObserver) {
    var przewMo = function () { new MutationObserver(przewZaplanuj).observe(document.body, { childList: true, subtree: true }); przewZaplanuj(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', przewMo); else przewMo();
  }
})();
